
import { Payload, PayloadCategory, Platform } from "@/types/profile";
import { accountsPayloads } from "./accounts";
import { advancedPayloads } from "./advanced";
import { educationPayloads } from "./education";
import { generalPayloads } from "./general";
import { mediaPayloads } from "./media";
import { networkPayloads } from "./network";
import { applicationsPayloads } from "./applications";
import { restrictionsPayloads } from "./restrictions";
import { securityPayloads } from "./security";

// Combine all payloads from category files
export const payloads: Payload[] = [
  ...accountsPayloads,
  ...advancedPayloads,
  ...educationPayloads,
  ...generalPayloads,
  ...mediaPayloads,
  ...networkPayloads,
  ...applicationsPayloads,
  ...restrictionsPayloads,
  ...securityPayloads
];

// Get payloads by category
export const getPayloadsByCategory = (category: PayloadCategory): Payload[] => {
  return payloads.filter(payload => payload.category === category);
};

// Get payloads by platform
export const getPayloadsByPlatform = (platform: Platform): Payload[] => {
  return payloads.filter(payload => payload.supportedPlatforms.includes(platform));
};

// Get all categories
export const getAllCategories = (): PayloadCategory[] => {
  const categories = new Set<PayloadCategory>();
  payloads.forEach(payload => categories.add(payload.category));
  return Array.from(categories);
};

// Check if payload supports a specific platform
export const isPayloadSupportedOnPlatform = (payloadId: string, platform: Platform): boolean => {
  const payload = payloads.find(p => p.id === payloadId);
  return payload ? payload.supportedPlatforms.includes(platform) : false;
};

// Get payload by ID
export const getPayloadById = (payloadId: string): Payload | undefined => {
  return payloads.find(p => p.id === payloadId);
};
